import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import store, { persistor } from './store';
import GlobalStyles from './styles/GlobalStyles';
import AppRoutes from './routes';
import SvgIcons from './components/SvgIcons';
import HeaderLocation from './components/Header/HeaderLocation';
import SidebarLocation from './components/SideBar/SideBarLocation';
import FooterLocation from './components/Footer/FooterLocation';
import ContentPages from './components/ContentPages';
import { NotificationProvider } from './components/Notification/NotificationContext';
import WebSocketProvider from './components/WebSocketProvider/WebSocketProvider';
import VersionChecker from './components/VersionChecker';
import ChatHandoffModal from './components/ChatHandoff/ChatHandoffModal';
import errorHandler from './utils/errorHandler';

// Expor store globalmente para acesso em WebSocketService
// eslint-disable-next-line no-underscore-dangle
window.__REDUX_STORE__ = store;

function App() {
  const [sidebarShrink, setSidebarShrink] = useState(false);

  // Inicializar sistema de tratamento de erros
  useEffect(() => {
    console.log('🛡️ Sistema de tratamento de erros inicializado');

    // Cleanup quando o componente for desmontado
    return () => {
      errorHandler.cleanup();
      console.log('🧹 Sistema de tratamento de erros limpo');
    };
  }, []);

  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <BrowserRouter>
          <NotificationProvider>
            <WebSocketProvider>
              <div>
                <Helmet>
                  <title>Os.OpenNew</title>
                  <link rel="icon" href="/img/icons/opennewIcon.png" />
                </Helmet>
                <HeaderLocation
                  setSidebarShrink={setSidebarShrink}
                  sidebarShrink={sidebarShrink}
                />
                <div className="d-flex align-items-stretch">
                  <SidebarLocation sidebarShrink={sidebarShrink} />
                  <ContentPages>
                    <AppRoutes />
                    <FooterLocation />
                  </ContentPages>
                </div>
                <GlobalStyles />
                <SvgIcons />
                <VersionChecker />
                <ChatHandoffModal />
              </div>
            </WebSocketProvider>
          </NotificationProvider>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  );
}

export default App;
